import React from "react";
import { Helmet } from "react-helmet";

import CareersHero from "./hero";
import CareerValues from "./values";
import Benefits from "./benefits";
import OpenRoles from "./openRoles";

const Careers = () => {
    const careersPageSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "https://www.partneredmg.com/careers#webpage",
        "url": "https://www.partneredmg.com/careers",
        "name": "Careers at Partnered Management Group | Join Our Team",
        "description":
            "Join a team of thoughtful operators, project leaders, and makers. See open roles in project management, operations, and design & development at PMG.",
        "isPartOf": { "@id": "https://www.partneredmg.com/#website" },
        "about": { "@id": "https://www.partneredmg.com/#organization" },
        "breadcrumb": { "@id": "https://www.partneredmg.com/careers#breadcrumb" },
    };

    const breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "@id": "https://www.partneredmg.com/careers#breadcrumb",
        "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.partneredmg.com/" },
            { "@type": "ListItem", "position": 2, "name": "Careers", "item": "https://www.partneredmg.com/careers" },
        ],
    };

    // Roles are placeholder content until this is wired to a real ATS, so no
    // JobPosting schema is emitted yet. Publishing JobPosting for roles that are
    // not genuinely open would put fabricated listings into Google for Jobs.
    return (
        <div className="w-full flex flex-col">
            <Helmet>
                <title>Careers at Partnered Management Group | Join Our Team</title>
                <meta
                    name="description"
                    content="Join a team of thoughtful operators, project leaders, and makers. See open roles in project management, operations, and design & development at PMG."
                />
                <link rel="canonical" href="https://www.partneredmg.com/careers" />
                <script type="application/ld+json">{JSON.stringify(careersPageSchema)}</script>
                <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
            </Helmet>

            <CareersHero />
            <CareerValues />
            <Benefits />
            <OpenRoles />
        </div>
    );
};

export default Careers;
